import {Component} from 'react';
import {connect} from "react-redux";
import queryString from "query-string"
import Storage from '../../services/Storage'


class TokenReceiver extends Component {

    componentDidMount(){
        const parsedParams = queryString.parse(window.location.search);
        if (parsedParams['code'] && Storage.getItem('login-uuid') === parsedParams.state) {
            Storage.setItem('auth-details', parsedParams);
            this.props.dispatchExchangeToken({token: parsedParams['code']})
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
  dispatchExchangeToken: (params)=>dispatch({type:'FETCH.CUSTOMER_EXCHANGE_TOKEN.REQUEST', params}),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TokenReceiver);
